'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.opacityIn = exports.slideDown = exports.scaleUp = undefined;

var _styles = require('./styles');

var keyframeShow = function keyframeShow() {
  return {
    '0%': {
      transform: 'scale(0)'
    },
    '100%': {
      transform: 'scale(1)'
    }
  };
};

var keyframeSlideDown = function keyframeSlideDown(_ref) {
  var size = _ref.size;
  return {
    '0%': {
      transform: 'translateY(' + size + ')'
    },
    '100%': {
      transform: 'translateY(0px)'
    }
  };
};

var keyframeOpacityIn = function keyframeOpacityIn() {
  return {
    '0%': {
      opacity: 0
    },
    '100%': {
      opacity: 1
    }
  };
};

var scaleUp = exports.scaleUp = function scaleUp(props) {
  return _styles.renderer.renderKeyframe(keyframeShow, props);
};
var slideDown = exports.slideDown = function slideDown(props) {
  return _styles.renderer.renderKeyframe(keyframeSlideDown, props);
};
var opacityIn = exports.opacityIn = function opacityIn(props) {
  return _styles.renderer.renderKeyframe(keyframeOpacityIn, props);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/styles/keyframes.js
// module id = 185
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38